import { z } from "zod";

/** RFC 9457 problem details. Every error response from the API has this shape. */
export const problemSchema = z.object({
  type: z.string().default("about:blank"),
  title: z.string(),
  status: z.number().int().min(100).max(599),
  detail: z.string().optional(),
  instance: z.string().optional(),
  requestId: z.string().optional(),
});

export type Problem = z.infer<typeof problemSchema>;

export const PROBLEM_CONTENT_TYPE = "application/problem+json";
